import { render } from "./PaginationLinks.vue?vue&type=template&id=13ce3944"
import script from "./PaginationLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationLinks.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/PaginationLinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13ce3944"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13ce3944', __exports__)) {
    api.reload('13ce3944', __exports__)
  }
  
  module.hot.accept("./PaginationLinks.vue?vue&type=template&id=13ce3944", () => {
    api.rerender('13ce3944', render)
  })

}


export default __exports__